import { PublicClientApplication } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_MICROSOFT_SSO_TENANT_ID || "common";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_SSO_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const microsoftLoginRequest = {
  scopes: ["openid", "profile", "email"],
};

let msalInstancePromise = null;

export function getMsalInstance() {
  const clientId = process.env.REACT_APP_MICROSOFT_SSO_CLIENT_ID;
  if (!clientId) {
    return Promise.resolve(null);
  }

  if (!msalInstancePromise) {
    const instance = new PublicClientApplication(msalConfig);
    msalInstancePromise = instance.initialize().then(() => instance);
  }
  return msalInstancePromise;
}
